import React, { useRef, useState, useId } from "react";
import './MyAccountManage.scss';
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function MyAccountManage({ }) {
    const navigate = useNavigate();
    const location = useLocation()
    const url = new URL(window.location.href);
    let arr = Array.apply(null, { length: 10 }).map(Number.call, Number);

    useEffect(() => {
        // window.scrollBy({
        //     top: 330,
        //     behavior: 'smooth'
        //   });
    }, []);


    return (
        <div className="MyAccountManage">
            <div className="MyAccountProjectsHeader">
                <div className="MyAccountProjectsHeaderLeft">
                    <h1>Account Management</h1>
                    <h2>Easily view and edit your account information.</h2>
                </div>
                <img src={require(`../../../Images/information.png`)} alt="Chimney Cleaning" />
            </div>
        </div >
    )
}

